export const imagesTypes = ['jpeg', 'png', 'jpg'];
export const videoTypes = ['mkv', 'mp4', 'mov', 'quicktime'];
export const gifType = 'gif';

export const kindsOfSports = ['baseball', 'basketball', 'cricket', 'cycling', 'esports', 'football', 'hockey', 'motorsport', 'racing', 'rugby', 'tennis', 'volleyball'];

export const marketStatuses = [
	{ label: 'all', value: 'all' },
	{ label: 'listed', value: 'listed' },
	{ label: 'Available to buy now', value: 'instant' },
];
